package com.exura.util

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.silk.style.CssStyleScope

enum class AriaCurrent(val value: String) {
    Page("page"),
    Step("step"),
    Location("location"),
    Date("date"),
    Time("time"),
    True("true");

    override fun toString() = value
}

fun Modifier.ariaCurrent(mode: AriaCurrent?): Modifier = attrsModifier {
    if (mode != null) {
        attr("aria-current", mode.value)
    }
}


fun CssStyleScope.ariaCurrent(block: CssStyleScope.() -> Modifier) {
    cssRule("[aria-current]") {
        block()
    }
}

fun CssStyleScope.ariaCurrentValue(mode: AriaCurrent, block: CssStyleScope.() -> Modifier) {
    cssRule("[aria-current='${mode.value}']") {
        block()
    }
}
